declare var angular: any;
import * as _ from 'underscore';

angular
  .module('UserBuildUpControllers', [])

  .controller('BuildUpTrainingHomeCtrl', [
    '$scope',
    'exam',
    'EXAM',
    function($scope, exam, EXAM) {
      var categories;
      // TODO linguaskill
      if (EXAM === 'toeic' || EXAM === 'linguaskill') {
        let sections = JSON.parse(JSON.stringify(exam.sections));

        sections = sections.map(function(section, index) {
          return {
            title: section.title,
            parts: section.parts
              .map(function(part, index2) {
                return _.first(section.parts, index2 + 1);
              })
              .map(parts => {
                let title;
                if (EXAM === 'lerobert') {
                  title = 'Module ' + _.pluck(parts, 'id').join(', ');
                } else {
                  title = 'Part ' + _.pluck(parts, 'id').join(', ');
                }

                return {
                  title,
                  subtitle:
                    _.pluck(parts, 'numberOfQuestions').join(' + ') +
                    ' questions',
                  url:
                    '#!buildup/on?' +
                    'part=' +
                    _.pluck(parts, 'id').join('&part=')
                };
              })
          };
        });

        categories = sections;
      } else if (EXAM === 'bright') {
        let getPart = function(nbQuestions, part) {
          return {
            title: nbQuestions + ' questions',
            url: '#!buildup/on?' + 'part=' + part + '&questions=' + nbQuestions
          };
        };

        categories = [
          {
            title: 'Oral',
            parts: [getPart(20, 1), getPart(40, 1), getPart(60, 1)]
          },
          {
            title: 'Écrit',
            parts: [getPart(20, 2), getPart(40, 2), getPart(60, 2)]
          }
        ];
      } else if (EXAM === 'lerobert') {
        let getNumberOfSupports = function(percentage) {
          return exam.sections[0].parts
            .map(s => s.numberOfQuestions)
            .map(s => Math.floor(s * percentage));
        };

        let sections = [
          {
            title: 'Entraînement progressif',
            parts: [
              {
                title: 'Entraînement court',
                subtitle: 'Durée : 25 minutes environ'
              },
              {
                title: 'Entraînement intermédiaire',
                subtitle: 'Durée : 50 minutes environ'
              },
              {
                title: 'Entraînement long',
                subtitle: 'Durée : 1 heure 15 environ'
              },
              {
                title: 'Faire un test blanc',
                subtitle: 'Durée : 1 h 45'
              }
            ]
          }
        ];

        sections[0].parts = sections[0].parts.map((s, index) => {
          let percentage = 0.27 * (index + 1);
          console.log('yolo', getNumberOfSupports(percentage));
          let nbs = getNumberOfSupports(percentage)
            .map(
              (nbQ, index) =>
                '#!buildup/on?' + `part=${index + 1}&questions=${nbQ}`
            )
            .join('&');

          if (sections[0].parts.length === index + 1) {
            nbs = '#!examen';
          }

          return {
            ...s,
            url: nbs
          };
        });

        categories = sections;
      }

      $scope.categories = categories;
    }
  ])

  .controller('BuildUpOnCtrl', [
    '$scope',
    'audio',
    'navbar',
    'trainingUtils',
    'exam',
    'examUtils',
    '$q',
    '$timeout',
    '$location',
    'EXAM',
    'api',
    '$mdDialog',
    function(
      $scope,
      audio,
      navbar,
      trainingUtils,
      exam,
      examUtils,
      $q,
      $timeout,
      $location,
      EXAM,
      api,
      $mdDialog
    ) {
      var nbQuestionsPerSupportByPart;
      var nbQuestionsToFetch;
      var timePart;
      var playlistAudio;
      var globalTimer;
      var supports = [];

      $scope.examData = exam.examData;
      $scope.isPositionningTest;
      $scope.estimationScore;
      $scope.option;
      $scope.userAnswersInput = {};

      init();
      audio.init(true, false);

      function init() {
        $scope.option = trainingUtils.getOptions();
        $scope.isPositionningTest = $scope.option.test;

        if ($scope.isPositionningTest) {
          navbar.goBackAction('Test', '#!exam');
          $scope.title = 'Test de positionnement';
          $scope.headline = 'Test de positionnement';
          if (EXAM === 'lerobert') {
            $scope.description = `Ce court test de 32 questions va vous permettre d’évaluer votre niveau et de fixer votre objectif.<br>
        Vous pouvez le repasser autant de fois que vous le souhaitez ; il sera toujours différent.
        `;
          } else {
            $scope.description =
              'L’objectif de cet entraînement est de vous aider à améliorer votre capacité de concentration, afin de réussir au mieux la Certification Le Robert.';
          }
        } else {
          if (!$scope.option.part.length) {
            $location.url('/training');
          }

          navbar.goBackAction('Entraînement', '#!training', 'navbar.training');
          $scope.title =
            'Entraînement sur les parties ' + $scope.option.part.join(' & ');
          $scope.headline = 'Entraînement fractionné';
          if (EXAM === 'lerobert') {
            $scope.description =
              'L’objectif de cet entraînement est de vous aider à améliorer votre capacité de concentration, afin de réussir au mieux la Certification Le Robert.';
          } else {
            $scope.description =
              'Cet entraînement vous apprend à enchaîner les 7 parties, petit à petit, afin d’augmenter votre niveau de concentration.';
          }
        }

        if (EXAM === 'toeic') {
          playlistAudio = true;
          globalTimer = true;
          nbQuestionsPerSupportByPart = [1, 1, 3, 3, 1, 4, 4];
          if ($scope.isPositionningTest) {
            nbQuestionsToFetch = [2, 4, 12, 12, 11, 4, 15];
            timePart = [null, null, null, null, 20, 10, 30];
          } else {
            nbQuestionsToFetch = [6, 25, 39, 30, 30, 16, 54];
            timePart = [null, null, null, null, 20, 10, 30];
          }
        } else if (EXAM === 'bright') {
          timePart = [null, null];
          // just to prevent case of manual url, because we passed the number of questions with parameters
          nbQuestionsToFetch = [20, 20];
          nbQuestionsPerSupportByPart = [1, 1];
          if (!$scope.isPositionningTest && $scope.option.questions) {
            nbQuestionsToFetch = new Array(
              nbQuestionsPerSupportByPart.length
            ).fill($scope.option.questions);
          }

          if ($scope.isPositionningTest) {
            nbQuestionsToFetch = [30, 30];
          }
        } else if (EXAM === 'linguaskill') {
          if ($scope.isPositionningTest) {
            nbQuestionsToFetch = [1, 1, 1, 1, 1, 1, 1];
            nbQuestionsPerSupportByPart = [1, 1, 1, 1, 1, 1, 1];
          }
        } else if (EXAM === 'lerobert') {
          timePart = [null, null];
          // just to prevent case of manual url, because we passed the number of questions with parameters
          nbQuestionsToFetch = new Array(16).fill(2);
          nbQuestionsPerSupportByPart = new Array(16).fill(1);
          if (!$scope.isPositionningTest && $scope.option.questions) {
            console.log('nbQuestionsToFetch', nbQuestionsToFetch);
            $scope.title = 'Entraînement fractionné';
            nbQuestionsToFetch = new Array(
              nbQuestionsPerSupportByPart.length
            ).fill($scope.option.questions);
            console.log('nbQuestionsToFetch', nbQuestionsToFetch);
          }
        }

        $scope.showToolbarCenter; //: 'timer' | 'audio_player'
        $scope.buildup = true;
        $scope.data = {
          answer: {},
          finished: false,
          loading: true,
          indexSupport: 0,
          nbSupports: undefined,
          autoplay: exam.examData.autoplay.initialValue,
          progress: 0 // display progress in bar
        };

        var index;
        var currentPart;
        getSupports().then(gSupports => {
          for (var i = 0; i < gSupports.length; i++) {
            currentPart = examUtils.showHelp({
              support: gSupports[i],
              currentPart: currentPart
            });

            index = examUtils.indexQuestionsSupport({
              support: gSupports[i],
              index: index
            });
          }

          var timerDuration = getTimer();
          if (timerDuration) {
            setTimer(timerDuration);
            $scope.showToolbarCenter = 'timer';
          } else {
            if (playlistAudio) {
              $scope.showToolbarCenter = 'audio_player';
              var songs = audio.setPlaylist(supports, 'training');
              audio.addTracks(songs);
            }
          }

          $scope.support = supports[$scope.data.indexSupport];
          setupSupport($scope.support);

          $scope.data.nbSupports = supports.length;
          $scope.data.loading = false;
        });

        function setTimer(duration) {
          setTime(duration * 60);
        }

        function getTimer() {
          return sum(
            $scope.option.part.map(function(part) {
              return timePart[part - 1];
            })
          );
        }
      }

      $scope.start = function() {
        $scope.started = true;
        if (playlistAudio) {
          audio.play();
        }
        if (globalTimer) {
          startTimer();
        }
      };

      $scope.pause = function() {
        if (playlistAudio) {
          audio.stop();
        }

        if (globalTimer) {
          stopTimer();
        }
      };

      $scope.saveAnswer = function(answer, support) {
        if (trainingUtils.checkFinishedSupport(support)) {
          trainingUtils.sendSupportAnswers(support, $scope.userAnswersInput);

          console.log(
            '🔥',
            $scope.data.autoplay,
            exam.examData.autoplay.initialValue
          );
          if ($scope.data.autoplay) {
            $scope.nextSupport();
          }
        }
      };

      $scope.previousSupport = function() {
        $scope.data.indexSupport--;
        $scope.support = supports[$scope.data.indexSupport];
        setupSupport($scope.support);
        updateRatio();
      };

      $scope.nextSupport = function() {
        // finished ?
        if ($scope.data.indexSupport === supports.length - 1) {
          finished();
        } else {
          $scope.data.indexSupport++;
          $scope.support = supports[$scope.data.indexSupport];
          setupSupport($scope.support);
          updateRatio();
        }
      };

      $scope.stop = function() {
        finished();
      };
      function finished() {
        $scope.pause();
        $scope.data.finished = true;
        $scope.supports = supports;
        _.each($scope.supports, function(support) {
          trainingUtils.correctAnswers(support, {});
        });

        if ($scope.isPositionningTest) {
          estimateScores();
        }
      }

      function estimateScores() {
        let nbAnswers = sum(
          $scope.supports.map(function(s) {
            return s.questions.length;
          })
        );
        let nbGoodAnswers = sum(
          $scope.supports.map(function(s) {
            return s.nbGoodAnswer;
          })
        );

        $scope.estimationScore = exam.estimatePercentScoreToGrid(
          nbGoodAnswers / nbAnswers
        );
        showConfirm();

        function showConfirm() {
          var confirm = $mdDialog
            .confirm()
            .title('Souhaitez-vous enregistrer votre score ?')
            .textContent(
              'Votre score estimé est de : ' + $scope.estimationScore
            )
            .ok('Sauvegarder')
            .cancel('Ne pas sauvegarder');

          $mdDialog.show(confirm).then(
            function() {
              api.insert_estimated_scores($scope.estimationScore);
            },
            function() {}
          );
        }
      }

      function setupSupport(support) {
        if (!playlistAudio && support && support.training_audio) {
          trainingUtils.loadAudioSupport(support);
        }
      }

      $scope.reload = function() {
        $location.url('/training');
      };

      function getSupports() {
        var promises = [];
        var partToFetch;
        partToFetch = nbQuestionsPerSupportByPart.map(function(nb, index) {
          return index + 1;
        });

        partToFetch.forEach(function(part, index) {
          var nbSupports = Math.floor(
            parseInt(nbQuestionsToFetch[part - 1]) /
              nbQuestionsPerSupportByPart[part - 1]
          );
          if (nbSupports === 0) {
            nbSupports = 1;
          }
          console.log('==', part, nbSupports);
          promises.push(trainingUtils.getSupports(part, nbSupports, true));
        });

        return $q.all(promises).then(function(res) {
          // r is for the top level
          console.log(res);
          _.map(res, function(sArray: any) {
            _.map(sArray, function(s) {
              supports.push(s);
            });
          });

          supports = trainingUtils.addTimerToSupports(supports);
          supports = _.sortBy(supports, function(support) {
            return support.part;
          });
          return supports;
        });
      }

      function updateRatio() {
        $scope.data.progress = Math.round(
          (($scope.data.indexSupport + 1) / $scope.data.nbSupports) * 100
        );
      }

      $scope.timer = {};
      function setTime(time) {
        $scope.timer.time = time;
      }
      function startTimer() {
        $scope.timer.started = true;
      }
      function stopTimer() {
        $scope.timer.started = false;
      }

      $scope.$on('track:id', function(event, data) {
        $timeout(function() {
          $scope.currentTrackId = data;
        });
      });

      function sum(arr) {
        return _.reduce<any, number>(
          arr,
          function(memo, num) {
            return memo + num;
          },
          0
        );
      }

      $scope.checkedOpenGapAnswer = trainingUtils.checkedOpenGapAnswer;
    }
  ]);
